var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 1.66669H3.33464C2.41797 1.66669 1.6763 2.41669 1.6763 3.33335L1.66797 18.3334L5.0013 15H16.668C17.5846 15 18.3346 14.25 18.3346 13.3334V3.33335C18.3346 2.41669 17.5846 1.66669 16.668 1.66669ZM7.5013 9.16669H5.83464V7.50002H7.5013V9.16669ZM10.8346 9.16669H9.16797V7.50002H10.8346V9.16669ZM14.168 9.16669H12.5013V7.50002H14.168V9.16669Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.38c8903fe336ab0d1669bcac21ac209c.svg";
export { ForwardRef as ReactComponent };